import axios from "axios";

/**
 * Delete cache from axios storage and local storage
 */
export const removeCache = async () => {
  for (var key in localStorage) {
    if (key.includes("transmission-list")) {
      localStorage.removeItem(key);
      await axios.storage.remove(key);
    }
  }
};
